import moment from 'moment';
import YEARFRAC from 'common/formulas/math.js/YEARFRAC';

const SUM_FROM_ACCRUED_LEDGER = (
  ledgerList: any,
  withCompounding: boolean,
  issuePrice: number,
  dividendRate: number,
  compoundingPeriods: number,
  measurementDate: string
) => {
  // In case we update/change this formulas, we need to update the formula on backend as well
  // (backend/apps/cap_table/services/securities/dividends.py)
  const getCalcAccruedDividends = () => {
    if (withCompounding) {
      return ({ date, shares }: { date: string; shares: number }) =>
        (issuePrice
          * (1 + dividendRate / compoundingPeriods) ** ((YEARFRAC(date, measurementDate, 3) as number) * compoundingPeriods)
          - issuePrice)
        * shares;
    }

    return ({ date, shares }: { date: string; shares: number }) =>
      dividendRate * issuePrice * shares * (YEARFRAC(date, measurementDate, 3) as number);
  };

  const returnZeroIfDateIsAfterMeasurementDate = (obj: any, fn: any) => {
    if (moment(obj.date, 'MM/DD/YYYY').isAfter(moment(measurementDate, 'MM/DD/YYYY'))) {
      return 0;
    }
    return fn(obj);
  };
  // (E4 * (1+E22/E24) ^ (YEARFRAC(E2, '01/10/2022', 3) * E24) - E4) * E5
  const calcAccruedDividends = getCalcAccruedDividends();
  return ledgerList.reduce(
    (sofar: number, next: any) => sofar + returnZeroIfDateIsAfterMeasurementDate(next, calcAccruedDividends),
    0
  );
};

export default SUM_FROM_ACCRUED_LEDGER;
